<template>
  <my-modal>
    <div id="modal-template">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h4 class="text-primary">
              <i class="fas fa-file-invoice-dollar btn-icon-wrapper btn-icon-sm"></i>
              Seleccionar Período de aportes
            </h4>
          </div>
          <div class="modal-body">
            <div class="row justify-content-center w-100">
              <h4 class="text-center mb-3 col-12">Período</h4>
              <float-label label="MES:" clase="col-md-4">
                <select id="mes" class="form-control" v-model="mes">
                  <option v-for="m in meses" :value="m" :key="m">
                    {{ m }}
                  </option>
                </select>
              </float-label>
              <float-label label="AÑO:" clase="col-md-4">
                <select id="año" class="form-control" v-model="año">
                  <option v-for="n in años" :key="n" :value="n">
                    {{ n }}
                  </option>
                </select>
              </float-label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="cerrarModal">
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="selectPeriodo"
            >
              Descargar
            </button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import FloatLabel from "@/components/layouts/FloatLabel";
import MyModal from "@/components/layouts/MyModal";
import axios from "axios";
export default {
  name: "ModalSeleccionarPersona",
  components: {
    FloatLabel,
    MyModal
  },
  data() {
    return {
      loading: false,
      fecha: new Date(),
      mes: "",
      año: null,
    };
  },
  computed: {
    años: function () {
      let array = [];
      for (let index = 2020; index <= 2035; index++) {
        array.push(index);
      }
      return array;
    },
    meses: function () {
      return [
        "ENERO",
        "FEBRERO",
        "MARZO",
        "ABRIL",
        "MAYO",
        "JUNIO",
        "JULIO",
        "AGOSTO",
        "SEPTIEMBRE",
        "OCTUBRE",
        "NOVIEMBRE",
        "DICIEMBRE",
      ];
    },
  },
  mounted() {

    this.año = this.$moment(this.fecha).format("YYYY");
    this.mes = this.$moment(this.fecha).format("MMMM").toUpperCase();
  },
  methods: {
    cerrarModal() {
      this.$emit("cerrarSelectPeriodo");
    },
    selectPeriodo() {
      const periodo = this.mes + " " + this.año;
      const url = axios.defaults.baseURL + "/aportes?periodo=" + periodo+"&institucion_id="+axios.defaults.headers.common['institucionId']
      console.log(encodeURI(url))
      window.location.href =url
    },
  },
};
</script>
